import HTTP from '@/plugins/http';
import Promise from "lodash/_Promise";

const merchantApi = {
  export: '/merchant/export',
  page: '/merchant/list/page',
  add: '/merchant/add',
  update: '/merchant/updateInfo',
  type: '/merchant/wallet/type',
  deduction: '/merchant/wallet/manual/deduction',
  recharge: '/merchant/wallet/manual/recharge',
  role: '/role/list/page',
  look: '/merchant/secretKey/look',
  look4Account: '/admin/getGoogleCode?',
  payoutOrders: '/orderRecord/payout/list/page',
  exportPayoutOrders: '/orderRecord/payout/export',
  payoutCounts: '/orderRecord/payout/count',
  channels: '/merchant/channel/list',
  transfer: '/merchant/balance/transfer',
  cb: '/orderRecord/manual/payout/callback/',
  amountHistory: '/merchant/balance/page',
  exportAmountHistory: '/orderRecord/balance/export',
  updateStatue: '/merchant/updateMerchantStatus',
  payoutBanks: '/admin/payout/bankInfo/list',
  payoutAddBank: '/admin/payout/bankInfo/add',
  payoutEditBank: '/admin/payout/bankInfo/update',
  payoutDeleteBank: '/admin/payout/bankInfo/delete',
  payoutBatchUpdateBank: '/admin/payout/bankInfo/batchUpdate',
  bankCodes: '/merchant/payout/bankCode/list',
  requestOtp: '/admin/payout/payoutTransfer',
  submitOtp: '/admin/payout/payoutOtp',
  manual: '/merchant/payout/manual/makeup/',
  reject: '/merchant/payout/reject/',
  resetGoogleKey: '/merchant/restGoogleCode',
  requestAutoPayOutPayOut: '/merchant/payout/auto/',
  exportAdminAccount: '/admin/export',
  bankrecords: '/merchant/payout/bankrecords/page',
  exportBankrecords: '/merchant/payout/bankrecords/export',
  IpLogs:'ipLogs/list/page',
  allOrder:'/merchant/payout/manual/makeup/batch',
  describeList: '/sys/pay/bank/getRemarkType',
  userUnlock: '/admin/unlock',
  getPayoutBalance: '/sys/pay/payoutbank/getPayoutBalance',
  videoUrl:'/admin/payout/bankInfo/getVideo',
  batchSet:'/sys/pay/payoutbank/batchSetting',
  Cache:'/merchant/refreshCache',
  qrCode1: '/admin/payout/bankInfo/genBankQrcode',//代付出款银行列表二维码
  qrCode2: '/merchant/payout/genPayOutBankOrderQrcode',//商户代付订单二维码
};

function submitOtp(data) {
  return HTTP({
    url: merchantApi.submitOtp,
    method: 'post',
    data
  });
}

function requestOtp(data) {
  return HTTP({
    url: merchantApi.requestOtp,
    method: 'post',
    data
  });
}

function getSupportBankCodes() {
  return HTTP({
    url: merchantApi.bankCodes,
    method: 'get'
  });
}

function getPayoutBanks(data) {
  return HTTP({
    url: merchantApi.payoutBanks,
    method: 'post',
    data
  });
}

function editPayoutBank(data) {
  return HTTP.loading({
    url: merchantApi.payoutEditBank,
    method: 'post',
    data
  });
}

function addPayoutBank(data) {
  return HTTP.loading({
    url: merchantApi.payoutAddBank,
    method: 'post',
    data
  });
}

function deletePayoutBank(data) {
  return HTTP({
    url: merchantApi.payoutDeleteBank,
    method: 'post',
    data
  });
}

function batchUpdatePayoutBank(data) {
  return HTTP({
    url: merchantApi.payoutBatchUpdateBank,
    method: 'post',
    data
  });
}

function exportMerchantBalanceHis({ data }) {
  return HTTP.loading({
    url: merchantApi.exportAmountHistory,
    method: 'post',
    responseType: 'blob',
    data
  });
}

function getMerchantBalanceHis({ data, params }) {
  return HTTP({
    url: merchantApi.amountHistory,
    method: 'post',
    data: {
      query: data,
      ...params
    }
  });
}

function getPayoutCount({ data }) {
  return HTTP({
    url: merchantApi.payoutCounts,
    method: 'post',
    data
  });
}

function getPayoutOrders({ data }) {
  return HTTP({
    url: merchantApi.payoutOrders,
    method: 'post',
    data
  });
}

function getPage({ data, params }) {
  return HTTP({
    url: merchantApi.page,
    method: 'post',
    data: { query: data, ...params }
  });
}

function getRole(data) {
  return HTTP({
    url: merchantApi.role,
    method: 'post',
    data
  });
}

function doTransfer(data) {
  return HTTP({
    url: merchantApi.transfer,
    method: 'post',
    data
  });
}

function getChannelList(data) {
  return HTTP({
    url: merchantApi.channels,
    method: 'post',
    data
  });
}

function getGoogleQrCode(data) {
  return HTTP({
    url: merchantApi.look4Account + data,
    method: 'get'
  });
}
// 重置Googlekey
function resetGoogleCodeKey(params) {
  return HTTP({
    url: merchantApi.resetGoogleKey,
    method: 'get',
    params
  });
}

function getCallback(data) {
  return HTTP({
    url: merchantApi.cb + data,
    method: 'get'
  });
}

function manualOrder(data) {
  return HTTP({
    url: merchantApi.manual + data,
    method: 'get'
  });
}

function rejectOrder(data) {
  return HTTP({
    url: merchantApi.reject + data,
    method: 'get'
  });
}

function getType() {
  return HTTP({
    url: merchantApi.type,
    method: 'get'
  });
}

function getSecretKeys(param) {
  return HTTP({
    url: merchantApi.look,
    method: 'post',
    data: param
  });
}

function doExport(data) {
  return HTTP.loading({
    url: merchantApi.export,
    method: 'post',
    responseType: 'blob',
    data,
    timeout:600000
  });
}

function exportPayoutOrders({ data }) {
  return HTTP.loading({
    url: merchantApi.exportPayoutOrders,
    method: 'post',
    responseType: 'blob',
    data,
    timeout:600000
  });
}

function doAdd(data) {
  return HTTP.loading({
    url: merchantApi.add,
    method: 'post',
    data
  });
}

function doDeduction(data) {
  return HTTP.loading({
    url: merchantApi.deduction,
    method: 'post',
    data
  });
}

function doRecharge(data) {
  return HTTP.loading({
    url: merchantApi.recharge,
    method: 'post',
    data
  });
}

function doUpdate(data) {
  return HTTP.loading({
    url: merchantApi.update,
    method: 'post',
    data
  });
}

function updateStatus(data) {
  return HTTP.loading({
    url: merchantApi.updateStatue,
    method: 'post',
    data
  });
}

function setAutoPayOut(data) {
  return HTTP({
    url: merchantApi.requestAutoPayOutPayOut + data.id,
    method: 'get'
  });
}

function exportAdminAccount({ data }) {
  return HTTP.loading({
    url: merchantApi.exportAdminAccount,
    method: 'post',
    responseType: 'blob',
    data:{}
  });
}

function getPayoutHistory(data) {
  return HTTP({
    url: merchantApi.bankrecords,
    method: 'post',
    data
  });
}

function exportBankrecords({ data }) {
  return HTTP.loading({
    url: merchantApi.exportBankrecords,
    method: 'post',
    responseType: 'blob',
    data
  });
}

function getIpLogs(data) {
  return HTTP({
    url: merchantApi.IpLogs,
    method: 'post',
    data
  });
}
function allMakeOrder(data) {
  return HTTP({
    url: merchantApi.allOrder,
    method: 'post',
    data
  });
}

function getDescribeList() {
  return HTTP({
    url: merchantApi.describeList,
    method: 'get'
  });
}

function userUnlock(params) {
  return HTTP({
    url: merchantApi.userUnlock,
    method: 'get',
    params
  });
}

function getPayoutBalance(data) {
  return HTTP({
    url: merchantApi.getPayoutBalance,
    method: 'post',
    data
  });
}

function getFaceVideo(data) {
  return HTTP({
    url: merchantApi.videoUrl,
    method: 'post',
    data
  });
}

function batchSettings(data) {
  return HTTP.loading({
    url: merchantApi.batchSet,
    method: 'post',
    data
  });
}

function refreshCache(params) {
  return HTTP({
    url: merchantApi.Cache,
    method: 'get',
    params
  });
}

function getQrCode(params) {
  return HTTP.loading({
    url: merchantApi.qrCode1,
    method: 'get',
    params
  });
}
function getQrCode2(params) {
  return HTTP.loading({
    url: merchantApi.qrCode2,
    method: 'get',
    params
  });
}

export default {
  doExport,
  doAdd,
  getPage,
  getRole,
  getType,
  doUpdate,
  doDeduction,
  doRecharge,
  getSecretKeys,
  getGoogleQrCode,
  getPayoutOrders,
  exportPayoutOrders,
  getPayoutCount,
  getChannelList,
  doTransfer,
  getCallback,
  manualOrder,
  rejectOrder,
  getMerchantBalanceHis,
  exportMerchantBalanceHis,
  updateStatus,
  getPayoutBanks,
  editPayoutBank,
  addPayoutBank,
  deletePayoutBank,
  batchUpdatePayoutBank,
  getSupportBankCodes,
  requestOtp,
  submitOtp,
  resetGoogleCodeKey,
  setAutoPayOut,
  exportAdminAccount,
  getPayoutHistory,
  exportBankrecords,
  getIpLogs,
  allMakeOrder,
  getDescribeList,
  userUnlock,
  getPayoutBalance,
  getFaceVideo,
  batchSettings,
  refreshCache,
  getQrCode,
  getQrCode2,
};



// WEBPACK FOOTER //
// ./src/api/merchant.js